
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-methodologies/[id]",
      function () {
        return require("private-next-pages/all-methodologies/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-methodologies/[id]"])
      });
    }
  